import SectionAmbassador from './SectionAmbassador';
export default SectionAmbassador;
